import { StateStorage } from 'zustand/middleware'
import { createStore } from '../.'
import { PlugToken, PlugTokenGroup } from '../../interfaces/common'

export interface CachedToken extends Omit<PlugToken, 'fee'> {
  fee?: string
}

interface TokenStore {
  tokens: CachedToken[]
  tokenGroups: PlugTokenGroup[]
  setTokens: (tokens: CachedToken[]) => void
  setTokenGroups: (tokenGroups: PlugTokenGroup[]) => void
}

export const createTokenStore = (storage: StateStorage) =>
  createStore<TokenStore>(
    storage,
    (set) => ({
      tokens: [],
      tokenGroups: [],
      setTokens(tokens) {
        set({
          tokens,
        })
      },
      setTokenGroups(tokenGroups) {
        set({
          tokenGroups,
        })
      },
    }),
    {
      persist: {
        name: 'dabTokens2',
        version: 0,
      },
    }
  )
